module.exports = __webpack_public_path__ + "img/mobilemoney.ace718e0.png";